import React, { useContext, useEffect, useState, useRef, useLayoutEffect, useMemo, Dispatch, SetStateAction } from "react";
import "./RightBarRestau.css"
import { AppContext } from "../../../context/AppContext";
import { TfiClose } from "react-icons/tfi";
import { MdFullscreen } from "react-icons/md";
import swoosh from "../../../image/Menu/swoosh.webp"
import whiteLine from "../../../image/icon/whiteLine.png"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { IoInformation } from "react-icons/io5";
import { MenuContentPage } from "../../../components/types/types";
import bottomLine from "../../../image/Menu/baseLine.webp"
import MaskBackground from "../../maskBackground/maskBackground";

type PlatCoord = [pageIndex: number, sideIndex: 0 | 1, itemIndex: number];

type platProps = { name: string; desc: string; img: string | ArrayBuffer | null; coords: PlatCoord };


interface RightBarProps {
    isFullScreen:boolean,
    dobbleMenu: [MenuContentPage,MenuContentPage][];
    setFullPlat?:Dispatch<SetStateAction<string>>;
}

const RightBar:React.FC<RightBarProps> = ({dobbleMenu,setFullPlat,isFullScreen}) => {
    const {showPlat,setShowPlat} =useContext(AppContext)
    const divRef = useRef<HTMLDivElement>(null);
    const topBarPhone = useMemo(() => {
        return isFullScreen ? 0 : 64;
    },[isFullScreen])

    const [currentPlat,setCurrentPlat] = useState<[string,string,string,string]>(["","","",""])
    const [platList,setPlatList] = useState<platProps[]>([])
    const [platListLoad,setPlatListLoad] = useState(false)
    const [position, setPosition] = useState("closed");
    const [showPageInfo,setShowPageInfo] = useState(false)
    const [showInfoImg,setShowInfoImg] = useState(false)
    useEffect(() => {
        setShowPlat([-1,0,0])
    },[])


   const generatePlatList = () => {
        const result: platProps[] = [];

        dobbleMenu.forEach(([page1, page2], pageIndex) => {
            [page1, page2].forEach((page, sideIndex) => {
            if (!page || !page.elements) return;

            let lineIndex = 0;

            page.elements.forEach((item) => {
                if (item.type === 'img') {
                return; 
                }
                const currentLineIndex = lineIndex;
                lineIndex += 1;
                if (item.type === 'text') {
                const props = item.props;
                if (props.image) {
                    result.push({
                    name: props.text,
                    desc: props.description || '',
                    img: props.image || '',
                    coords: [pageIndex, sideIndex as 0 | 1, currentLineIndex],
                    });
                }
                }
            });
            });
        });

        return result;
    };
    const currentPlatIndex = useMemo(() => {
        if (!showPlat || showPlat[0] === -1 || platList.length === 0) return -1;
        
        return platList.findIndex(p => {
            if (!Array.isArray(p.coords) || p.coords.length < 3) return false;
            const [pIndex, sIndex, iIndex] = p.coords;
            return (
                pIndex === showPlat[0] &&
                sIndex === showPlat[1] &&
                iIndex === showPlat[2]
            );
        });
    }, [showPlat, platList]);

    const isLoadingRef = useRef(false);
    const loadNext = (next:platProps) => {
        
        if (isLoadingRef.current) return;
        isLoadingRef.current = true;
        const finish = () => {
            setShowPlat(next.coords);
            isLoadingRef.current = false;
        };
        if (!next.img) {
            finish();
        } else {
            const img = new Image();
            img.src = next.img as string;
            img.onload = finish;
            img.onerror = finish;
            img.decoding = 'async';
        }
    }

    const goToNextPlat = () => {
        if (platList.length === 0) {
            const list:platProps[] = generatePlatList();
            setPlatList(list);
            setPlatListLoad(true)
            if (list.length > 1) loadNext(list[1])
            return;
        }
        if (currentPlatIndex !== -1 && currentPlatIndex < platList.length - 1) {
            loadNext(platList[currentPlatIndex + 1])
        } else if (currentPlatIndex === platList.length-1) {
            setShowPageInfo(true)
        }
    };

    const goToPrevPlat = () => {
        setShowPageInfo(false)
        if (platList.length === 0) {
            const list:platProps[] = generatePlatList();
            setPlatList(list);
            setPlatListLoad(true)
            return; 
        }
        if(showPageInfo) {
            setShowPageInfo(false)
        }
        else if (currentPlatIndex > 0) {
            loadNext(platList[currentPlatIndex - 1])    
        }
    };
    
    useEffect(() => {
        if(showPlat[0] !== -1) {
            if (!platListLoad && (!platList || platList.length === 0)) {
                const list = generatePlatList();
                setPlatList(list);
                setPlatListLoad(true);
            }

            const menuSection = dobbleMenu?.[showPlat[0]];
            const menuPage = menuSection?.[showPlat[1]];
            const filteredItems = menuPage?.elements?.filter(el => el.type !== 'img') ?? [];
            const tempPlat = filteredItems?.[showPlat[2]];

            if (tempPlat && tempPlat.type === 'text') {
                const tempProps = tempPlat.props;
                setCurrentPlat([tempProps.text, tempProps.description || '',tempProps.image || '',tempProps.price?.toString() || '']);
            }
            if(position !== 'full' ){
                setTimeout(() => {
                    setPosition('full') 
                },100)
            }
        } else {
            setTimeout(() => {
                setCurrentPlat(['','','','']);
            },100)
        }
    },[showPlat])

    

    const startY = useRef(0);
    const [dragY, setDragY] = useState<number | null>(null);
    const startTime = useRef(0);
    const containerBarRef = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        if(containerBarRef.current) containerBarRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        const el = containerBarRef.current;
        if (!el) {
        const retryTimeout = setTimeout(() => {
            const retryEl = containerBarRef.current;
            if (retryEl) {
            attachTouchMoveEvent(retryEl);
            }
        }, 200);
        return () => clearTimeout(retryTimeout);
        }
    
        attachTouchMoveEvent(el);
    }, [position]);
    const attachTouchMoveEvent = (el:HTMLDivElement) => {
        const handleTouchMoveWrapper = (e: TouchEvent) => {
            const currentY = e.touches[0].clientY;
            const deltaY = currentY - startY.current;
            const isScrollingDown = deltaY > 0;
            const contentEl = el.querySelector('.content') as HTMLElement | null; 
            const isAtTop = contentEl ? contentEl.scrollTop === 0 : true;
        
            if (position === 'full' && isAtTop && isScrollingDown) {
                if(e.cancelable) e.preventDefault(); 
                el.style.overflowY = 'hidden';
            }else {
                el.style.overflowY = 'auto';
            }
        
            if(isAtTop) {
            const baseTop = position === 'full' ? topBarPhone : window.innerHeight;

            let newTop = baseTop + deltaY;

            newTop = Math.max(topBarPhone, Math.min(newTop, window.innerHeight));

            setDragY(newTop);
            }
        };  
        el.addEventListener('touchmove', handleTouchMoveWrapper, { passive: false });
    }
    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        startY.current = e.touches[0].clientY;
        startTime.current = Date.now();
    };

    const handleTouchEnd = () => {
        const endTime = Date.now();
        const duration = endTime - startTime.current;
        const deltaY = dragY !== null ? dragY - startY.current : 0;

        const snapPoints = {
            full: topBarPhone,
            closed: window.innerHeight
        };
        const SWIPE_THRESHOLD = 14; 
        const TIME_THRESHOLD = 500;
        if (Math.abs(deltaY) > SWIPE_THRESHOLD && duration < TIME_THRESHOLD) {
            if (deltaY >= 0 && position === 'full' && deltaY > window.innerHeight * 0.01) {
                setPosition('closed');
                setShowPageInfo(false)
            }
        } else {
            if (dragY !== null) {
                const distances = Object.entries(snapPoints).map(([key, val]) => ({
                key,
                distance: Math.abs(val - dragY),
                }));
        
                const closest = distances.sort((a, b) => a.distance - b.distance)[0].key;
                setPosition(closest as 'full' | 'closed');
                if(closest === 'closed') setShowPageInfo(false)
            }
        }
        setDragY(null);
    };    


    const handleClickImg = () => {
        if(currentPlat[2] !== "" && setFullPlat ) setFullPlat(currentPlat[2])
    }
    function useIsMobile() {
        const [isMobile, setIsMobile] = useState(false);

        useEffect(() => {
            function checkMobile() {
            setIsMobile(window.matchMedia('(max-width: 1049px)').matches);
            }
            checkMobile();
            window.addEventListener('resize', checkMobile);
            return () => window.removeEventListener('resize', checkMobile);
        }, []);

        return isMobile;
    }
    const reficonInfoVisualTel = useRef<HTMLDivElement|null>(null)
    const reficonInfoVisual = useRef<HTMLDivElement|null>(null)
    const refInfoVisual = useRef<HTMLDivElement|null>(null)
     useEffect(() => {
        const handleClickOutsideInfoImgUser = (event: MouseEvent) => {
            if ((reficonInfoVisualTel.current && !reficonInfoVisualTel.current.contains(event.target as Node)) && (refInfoVisual.current && !refInfoVisual.current.contains(event.target as Node)) && (reficonInfoVisual.current && !reficonInfoVisual.current.contains(event.target as Node))) {
                setShowInfoImg(false); 
            }
        };
    
        if (showInfoImg) {
            document.addEventListener("mousedown", handleClickOutsideInfoImgUser);
        }
    
        return () => {
            document.removeEventListener("mousedown", handleClickOutsideInfoImgUser);
        };
    }, [showInfoImg]); 
    const isMobile = useIsMobile();
    
    return (
        <>
            <div className='rightBarRestau'>
                {currentPlat[0] !== "" ? <p className="midTitle">{currentPlat[0]}</p> : <p className="largeTitle">Carte interactive</p>}
                <img src={whiteLine} className="whiteLine" loading="lazy" alt="ligne"/>
                
                    <div className="containerImg">
                    {currentPlat[2] === "" ? (
                    <div className="emptyImg smallText">
                        {currentPlat[0] === "" 
                        ? <p>Cliquer sur les plats avec le symbole "&nbsp;<span></span>&nbsp;" pour voir leur photo.</p>
                        : "Aucune photo, venez le découvrir !"}
                        <img src={swoosh} loading="lazy" alt="ligne"/>
                    </div>
                    ) : (
                    <div onClick={handleClickImg}>
                        <img className="imgPlat" src={currentPlat[2]} alt="plat" loading="lazy" />

                        <div ref={reficonInfoVisual} style={{position:'absolute',inset:0,width:'100%',height:'100%'}}><IoInformation className="infoImg pointer lowOpacityHover"  size={18} onClick={(e) => {e.stopPropagation();setShowInfoImg(!showInfoImg)}}/></div>
                        {showInfoImg && <div className="containerExplainVisual"  ref={refInfoVisual} onClick={(e) => {e.stopPropagation();setShowInfoImg(!showInfoImg)}}>
                                <span className="XsmallText">Visuel non contractuel. La composition et la présentation peuvent varier selon les arrivages et les conditions de service.</span>
                            </div>}
                            
                        {setFullPlat && <MdFullscreen className="fullScreen pointer lowOpacityHover" size={25} />}
                    </div>
                    )}

                    </div>
                    {(currentPlat[0] !== "" && currentPlat[1] !== "") && <div className="name smallTitle">Description :</div>}
                    <div className="desc smallText">{currentPlat[1]}</div>
                    {currentPlat[0] !== "" && <div className="containerButton XsmallText">
                        <div onClick={() => {if(currentPlatIndex > 0) {goToPrevPlat()}}} style={{opacity:(currentPlatIndex > 0 || currentPlatIndex===-1) ? '100%' : '50%', padding: '5px 20px 5px 10px'}}><FiChevronLeft size={20} style={{minWidth:'fit-content'}}/> <span>{window.innerWidth < 1400 ? 'Préc.' : 'Précédent'}</span></div>
                        <div onClick={() => {if(currentPlatIndex < (platListLoad ? platList.length-1 : 1)) {goToNextPlat()}}} style={{opacity:currentPlatIndex < (platListLoad ? platList.length-1 : 1) ? '100%' : '50%',padding: '5px 10px 5px 20px'}}> <span>{window.innerWidth < 1400 ? 'Suiv.' : 'Suivant'}</span> <FiChevronRight size={20} /></div>
                    </div>}
            </div>
            {
                (currentPlat[1] !== "" || currentPlat[2] !== "")   &&   <>
                    <div className={`rightBarRestauTel ${position} ${isFullScreen ? 'isFullScreen' : ''}`} ref={containerBarRef} style={dragY !== null ? { top: `${dragY}px`, transition: 'none' } : {}} onTouchStart={handleTouchStart}   onTouchEnd={handleTouchEnd} onClick={(e) => e.preventDefault()}>
                        <div className="close" onClick={() => {setPosition('closed');setTimeout(() => {setShowPageInfo(false)},500)}}>
                            <TfiClose className="elem" size={15} />
                        </div>
                        <div className="topBarBorder"></div>
                        {showPageInfo ? <div className="showPageInfo">
                            <p className="largeTitle" >Il reste peut-être des plats à <strong>découvrir</strong></p>
                            <img src={bottomLine} style={{width:'55%',marginTop:'10%',marginBottom:'10%'}} alt="decoration" />
                            <p className="midText" >Tous les plats ne sont pas forcémment interactif : pensez à consulter la carte pour ne rien manquer.</p>

                            <div>
                                <span className="firstLine XsmallText" >Les plats interactifs sont indiqués</span>
                                <div className="secondLine XsmallText"><span>sur la carte par le symbole "</span><div className="interactPoint"></div><span>".</span></div>
                            </div>
                        </div>
                        : <>
                            <div className="name largeTitle" >{currentPlat[0]}</div>
                            
                            <div className="content" ref={divRef} >
                                { currentPlat[2] !== "" && <div className="containerImg">
                                    
                                        <img src={currentPlat[2] } key={currentPlat[2]} alt="plat"/>
                                        <div ref={reficonInfoVisualTel} style={{position:'absolute',inset:0,width:'100%',height:'100%'}}><IoInformation className="infoImg pointer lowOpacityHover"  size={25} onClick={(e) => {e.stopPropagation();setShowInfoImg(!showInfoImg)}}/></div>
                                        {showInfoImg && <div className="containerExplainVisual"  ref={refInfoVisual} onClick={(e) => {e.stopPropagation();setShowInfoImg(!showInfoImg)}}>
                                                <span className="XsmallText">Visuel non contractuel. La composition et la présentation peuvent varier selon les arrivages et les conditions de service.</span>
                                            </div>}
                                    </div>
                                }
                                
                                <div className="descBar midTitle">
                                    
                                    {(currentPlat[1] || (currentPlat[3] && currentPlat[3]!=='0' && currentPlat[3] !== '-1')) && <div className="nameDesc " >Description :</div>}
                                    {currentPlat[3] && currentPlat[3]!=='0' && currentPlat[3] !== '-1' && <div className="price ">{currentPlat[3]} €</div>}
                                </div>
                                {currentPlat[1] && <i className="desc midText">{currentPlat[1]}</i>}
                            </div>
                        </>}
                        <div className="containerButton smallText">
                            <div onClick={() => {if(currentPlatIndex > 0 || showPageInfo) {goToPrevPlat()}}} style={{opacity:(currentPlatIndex > 0 || currentPlatIndex===-1 ||showPageInfo) ? '100%' : '50%', padding: '5px 20px 5px 10px'}}><FiChevronLeft size={20} style={{minWidth:'fit-content'}}/> <span>Précédent</span></div>
                            <div onClick={() => {if(currentPlatIndex < (platListLoad ? platList.length : 1)) {goToNextPlat()}}} style={{opacity:!showPageInfo ? '100%' : '50%',padding: '5px 10px 5px 20px'}}> <span>Suivant</span> <FiChevronRight size={20} /></div>
                        </div>
                    </div>
                            {position === 'full' && isMobile && !isFullScreen && <div className="maskRightBarRestauTel"> <MaskBackground /></div>  }
                    </>
            }
            
                
        </>
    )
}


export default RightBar